// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"InputCheckbox_checkboxWrapper__2wAqz","checkbox":"InputCheckbox_checkbox__3gPmy","label":"InputCheckbox_label__2oNoo","info":"InputCheckbox_info__1monh"};